import { AppConfigService } from './Services/app-config.service';

export function AppIntializer(appConfig: AppConfigService) {
    return async () => await appConfig.initialise();
}